import { string } from 'yup';

const rule = {
	name: 'phoneNumber',
	method ({ message } = { message: 'Please enter a valid phone number' }) {

		return this.test('phoneNumber', message, function (value) {

			if (value === '') {

				return true;

			}

			const { createError } = this;
			return /^\(?(\d{3})\)?[-. ]?(\d{3})[-. ]?(\d{4})$/.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
